import UnlockPrompt from './UnlockPrompt';

export default UnlockPrompt;
